import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { ImageLightboxService } from '@core/services';
import { ImageLightboxComponent } from '../image-lightbox/image-lightbox.component';

@Component({
  selector: 'app-image-lightbox-host',
  imports: [CommonModule, ImageLightboxComponent],
  templateUrl: './image-lightbox-host.component.html',
  styleUrl: './image-lightbox-host.component.scss',
})
export class ImageLightboxHostComponent {
  private readonly imageLightboxService = inject(ImageLightboxService);

  readonly lightbox$ = this.imageLightboxService.lightbox$;

  onClose(): void {
    console.log('close');
    this.imageLightboxService.close();
  }

  onNext(): void {
    this.imageLightboxService.next();
  }

  onPrevious(): void {
    this.imageLightboxService.previous();
  }

  onSelect(index: number): void {
    this.imageLightboxService.goTo(index);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.imageLightboxService.close();
  }

  @HostListener('document:keydown.arrowleft')
  onArrowLeft(): void {
    this.imageLightboxService.previous();
  }

  @HostListener('document:keydown.arrowright')
  onArrowRight(): void {
    this.imageLightboxService.next();
  }
}
